// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__kP3uu","colMaxWidth":"Table_colMaxWidth__w-iCq"};